// extracted by mini-css-extract-plugin
module.exports = {"List":"O7k9IFZiauTAPLnOCbHXP"};